// extracted by mini-css-extract-plugin
module.exports = {"label":"MarketingCheckbox_label__1jtV6"};